import React, { useContext, useEffect } from "react";
import SearchApplication from "../components/search/SearchApplication";
import { MobileDrawerContext } from "../context/MobileDrawerContext";

/**
 * Renders the search site.
 *
 * @returns {JSX.Element}
 */
function SearchSite() {
  const showMobileDrawerButton = useContext(MobileDrawerContext)
    .showMobileDrawerButtonDispatch;

  // Hide the mobile drawer button.
  useEffect(() => {
    showMobileDrawerButton({ type: "show" });
  }, [showMobileDrawerButton]);

  return (
    <div>
      <SearchApplication />
    </div>
  );
}

export default React.memo(SearchSite);
